import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthenticationService } from '../../services/authentication.service';
import ToastService from '../../services/toast.service';
import logger from '../../utils/logger';

function PrivateRoute({ roles, children }) {
  const auth = useAuthenticationService();
  const isAuthenticated = auth.isAuthenticated();
  const isAuthorized = isAuthenticated && (!roles || roles.length === 0 || auth.isInAnyRole(roles));

  useEffect(() => {
    if (isAuthenticated && !isAuthorized) {
      ToastService.warn('You are not authorized to view this page', 'privateroute', {
        closeOnClick: false
      });
      window.history.back();
    }
  }, [isAuthenticated, isAuthorized]);

  if (!isAuthenticated) {
    logger.log('Navigate to login');
    return <Navigate to='/login' />;
  }

  if (!isAuthorized) {
    logger.log('Not authorized');
    return null;
  }
  return children;
}

export default PrivateRoute;
